import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronsDownIcon = createIcon(
  <React.Fragment>
    <polyline points="7 13 12 18 17 13" />
    <polyline points="7 6 12 11 17 6" />
  </React.Fragment>,
  'ChevronsDownIcon'
);
